import { Box, Button, Container, Typography } from '@montugroup/design-system';
import { styled, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

import BackButton from '@/components/buttons/BackButton';
import Error from '@/components/error/Error';
import ProductDetailsLoadingBlock from '@/components/products/productDetailsV2/ProductDetailsLoadingBlock';
import useProductDetails from '@/hooks/products/useProductDetails';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { ProductDetails } from '@montugroup/circuit-shared/components/product-detail/ProductDetails';

const ProductContainer = styled(Box)(({ theme }) => ({
  width: '100%',

  [theme.breakpoints.up('md')]: {
    display: 'flex',
    gap: theme.spacing(6),
  },
}));

const ContentContainer = styled(Container)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BackLinkContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(6),
  display: 'flex',
}));

export default function ProductDetailsPageV2() {
  const enableProductDetailPageRealDeviceImages = useFeatureFlag('enable_product_detail_page_real_device_images');
  const { id: productId } = useParams();

  const navigate = useNavigate();

  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down('md'));

  const { product, isError, isLoading } = useProductDetails(productId || '');

  if (isLoading) {
    return <ProductDetailsLoadingBlock />;
  }

  if (isError || !product) {
    return (
      <ContentContainer>
        <Error
          status={product ? 500 : 404}
          buttons={[
            // eslint-disable-next-line react/jsx-key
            <Button variant="contained" onClick={() => navigate(-1)}>
              Back to Medicine information
            </Button>,
          ]}
        />
      </ContentContainer>
    );
  }

  return (
    <Box>
      <ProductContainer>
        {isMobileView && (
          <BackLinkContainer>
            <BackButton />
            <Typography variant="h5" component="h5" sx={(theme) => ({ color: theme.palette.primary.main })}>
              Medicine information
            </Typography>
          </BackLinkContainer>
        )}

        <ProductDetails
          product={product}
          showDescription={true}
          showUsage={true}
          enableProductDetailPageRealDeviceImages={enableProductDetailPageRealDeviceImages}
        />
      </ProductContainer>
    </Box>
  );
}
